<template>
  <div>
    <navbar-header/>
    <pizza-dough-screen></pizza-dough-screen>
  </div>
</template>

<script>
import PizzaDoughScreen from '../components/PizzaDoughScreen'
import NavbarHeader from '../components/NavbarHeader'
export default {
  name: 'PizzaDoughLayout',
  components: {PizzaDoughScreen, NavbarHeader}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/PizzaDoughLayout.vue